import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';

export type UserActivatedPayload = UserPayload;

export type UserActivatedAction = {
	type: 'USER_ACTIVATED';
	payload: UserActivatedPayload;
	accountId: number;
};

export default (payload: UserActivatedPayload, accountId: number): UserActivatedAction => ({
	type: 'USER_ACTIVATED',
	payload,
	accountId,
});
